module.exports = __webpack_public_path__ + "img/Thermometer.209f0cb0.svg";